import { Cookies } from "react-cookie";
import { CookieChangeOptions } from "universal-cookie";

const cookies = new Cookies();

export const setCookie = ({ name, value, options }: CookieChangeOptions) => {
  return cookies.set(name, value, { ...options });
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const removeCookie = (name: string) => {
  return cookies.remove(name, { path: "/" });
};
